import React, { useContext, useEffect, useState } from "react";
import { ExpertiseContext } from "../../App";

function FirstComponent() {
  const [isExpCenter, setIsExpCenter] = useState(true);
  const expertiseList = useContext(ExpertiseContext);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setIsExpCenter(false)
      }
      else{
        setIsExpCenter(true)
      }
      // console.log(window.scrollY);
    });
  }, []);
  return (
    <div className="w-full gap-y-3 md:gap-y-5 flex flex-col justify-center items-center text-center text-white">
      <div className="w-full py-8 flex flex-col bg-black bg-opacity-20 justify-center items-center rounded-lg">
        <p className="p-2 text-5xl md:text-7xl lg:text-9xl animate__animated animate__zoomIn text-transparent bg-clip-text bg-gradient-to-br from-[#00B3E1] to-[#4A57BF]">
          An IT solution <br />
          Company
        </p>
      </div>
      {isExpCenter ? (
        <div className="w-full pt-5 md:pt-0 flex flex-col gap-y-2">
          <div className="w-full flex justify-start items-center">
            <div className="w-1/2 flex justify-between items-center">
              <h2 className="pl-2 text-xl  md:text-3xl animate__animated animate__fadeInLeft">Expertise</h2>
              {/* <button className="text-xl">
                <img
                  src="icons/arrow.png"
                  alt="arrow-icon"
                  className="animate__animated animate__heartBeat hover:scale-110"
                />
              </button> */}
            </div>
          </div>
          <div className="w-full bg-slate-100 text-black py-1">
            <div id="moving_container" className="w-full md:text-xl flex justify-start items-center gap-x-10">
              {
                expertiseList.map((expertise) => {
                  return(
                    <div key={expertise.id} className="">
                      <p className="">{expertise.title}</p>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      ) : (
        <div className="text-3xl md:text-5xl pt-10 animate__animated animate__heartBeat">
          <p className="text-slate-100">Expertise</p>
        </div>
      )}
    </div>
  );
}

export default FirstComponent;
